import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  baseAPI,
  personaFinanceGeneralApiURL,
  personaPersonalApiURL,
  personasProfileCompanyApiURL,
  workingHoursPersonalApiURL,
  personaFinanceCostsApiURL,
  personaOperationsGeneralApiURL,
  personaOperationsOrganizationChartApiURL,
  personaOperationsDomainApiURL,
  personaOperationsKpiApiURL,
  personaVariableCompensationGeneralApiURL,
  personaCertificatesGeneralApiURL,
  personaCertificatesAchievementApiURL,
  personaAccountGeneralApiURL,
  personaIdentificationGeneralApiURL,
  personaGdprPdpaApiURL,
  personaGdprSadApiURL,
  personaRelationshipEmployessApiURL,
  personaRelationshipSuppliersApiURL,
  personaApiURL,
  personaEquipmentApiURL
} from '../../services/apiRoutes';
import { PaginationObject } from '../../models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from '../../models/sortObject';

@Injectable({
  providedIn: 'root',
})
export class HomepageService {
  constructor(public http: HttpClient) { }
  /* personas sections */

  async getPersonas(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        personaApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) +
        query
      )
      .toPromise();
  }

  /* personas sections end */

  /* profile sections */
  async getPersonasProfileCompany(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        personasProfileCompanyApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) +
        query
      )
      .toPromise();
  }

  async getPersonasProfilePersonal(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaPersonalApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) +
        query
      )
      .toPromise();
  }

  async getPersonasProfileWorkingHours(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        workingHoursPersonalApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) + 
        query
      )
      .toPromise();
  }

  /* profile sections end */

  /* relationship sections */

  async getPersonasRelationshipEmployees(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaRelationshipEmployessApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }


  async getPersonasRelationshipSuppliers(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaRelationshipSuppliersApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  /* relationship sections */


  /* finance sections */

  async getPersonasFinanceGeneral(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaFinanceGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getPersonasFinanceCosts(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaFinanceCostsApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  /* finance sections end */

  /* operations sections */

  async getPersonasOperationsGeneral(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaOperationsGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getPersonasOperationsOrganizationChart(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaOperationsOrganizationChartApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getPersonasOperationsDomain(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaOperationsDomainApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getPersonasOperationsKpi(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaOperationsKpiApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  /* operations sections end */

  /* variable compensation */
  async getPersonasVariableCompensation(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaVariableCompensationGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  /* variable compensation end */

  /* certification compensation */
  async getPersonasCertificationGeneral(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaCertificatesGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }


  async getPersonasCertificationAchievements(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaCertificatesAchievementApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  /* variable compensation end */

  /* account */
  async getPersonasAccountGeneral(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaAccountGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  /* account end */

  /* gdpr */
  async getPersonasGdprSad(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaGdprSadApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getPersonasGdprPdpa(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaGdprPdpaApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  /* gdpr end */

  /* identification */
  async getPersonasIdentificationGeneral(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaIdentificationGeneralApiURL +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  /* identification end */

  /* equipment */
  async getEquipmentComputer(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/computer' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getEquipmentSimCard(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/simcard' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getEquipmentCompanyCar(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/companycar' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getEquipmentFuelcard(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/fuelcard' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }


  async getEquipmentTelepass(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/telepass' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getEquipmentElectronicMealCard(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/electronicmealcard' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }

  async getEquipmentOfficeAccessKey(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        baseAPI +
        personaEquipmentApiURL + '/officeaccesskey' +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true)
        + query
      )
      .toPromise();
  }
  
  /* equipment end */
}
